import { CacheResolverMap } from 'apollo-cache-inmemory'

export const cacheRedirects: CacheResolverMap = {
  Query: {
    localizedString: (_, args, { getCacheKey }) =>
      getCacheKey({ __typename: 'LocalizedString', key: args.key }),
  },
}
